var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',[_c('RoleEditorView',{attrs:{"loading":_vm.innerLoading,"role-id":_vm.roleId,"menu-tree":_vm.menuTree,"init-form":_vm.initForm,"selectedKeys":_vm.selectKeys},on:{"save":_vm.handleSave,"back":_vm.handleBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }